import { Accordion } from '../../../../../components/general/accordion';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import { Table } from '../../../../../components/general/table';
import { useAccountHabeasDataHistory } from './hook';

export const AccountHabeasDataHistory = () => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useAccountHabeasDataHistory();

    return (
        <Accordion
            title="HISTÓRICO HABEAS DATA"
            icon={<FingerprintIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={total}
                loading={loading}
                paginationModel={{
                    page,
                    pageSize,
                }}
                onPaginationModelChange={paginator}
                pageSizeOptions={[2, 10, 20, 50]}
                disableRowSelectionOnClick
            />
        </Accordion>
    );
};
